import React, { useEffect } from "react";
import Layout from "../../Components/Layout/Layout";
import LayoutFull from "../../Components/Layout/LayoutFull";
import LayoutAccount from "../../Components/Layout/LayoutAccount";
import AfiliatedAccounts from "../../Components/Account/AfiliatedAccounts";
import { Message } from "rsuite";
import InvitedAccounts from "./InvitedAccounts";

const InviteNewPartner = ({}) => {

	var url = new URL(window.location);
    const invitationAccepted = url.searchParams.get('invitation_accepted') === 'true';

	useEffect( () => {

	}, [])

	return (
		<LayoutAccount>
			{ invitationAccepted && (
				<Message showIcon type="success" header="Invitación aceptada" closable>
                    Invitación aceptada exitosamente.
                </Message>
			)}
			<div>
				<InvitedAccounts />
			</div>
		</LayoutAccount>
	)
};

export default InviteNewPartner;